import axios from 'axios'
import API_URL from '@/router/api'
import NuxtRequest from '@/service/nuxt-request'

export const flushCache = () => {
    return new Promise((resolve, reject) => {

        const nuxtRequest = new NuxtRequest()

        nuxtRequest.post(API_URL.setting.flushCache)
            .then(resolve)
            .catch(reject)
    })
}

export const sendNewsletter = () => {
    return new Promise((resolve, reject) => {

        axios.post(API_URL.setting.sendNewsletter)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
